module.exports = __webpack_public_path__ + "static/media/portfolio1 (3).dc038c67.jpeg";